import { PropsWithChildren, useMemo, useState } from "react";
import {
  SelectedVehiclesFilter,
  SelectedVehiclesFilterContext,
} from "./common";

export const MaintenanceDashboardSelectedVehiclesContext = ({
  children,
}: PropsWithChildren<{}>) => {
  const [selectedFilter, setSelectedFilter] = useState<
    SelectedVehiclesFilter
  >();
  const selectedFilterAccessor = useMemo(
    () => ({
      selectedFilter,
      setSelectedFilter: (value?: SelectedVehiclesFilter) =>
        setSelectedFilter((x) => (x === value ? undefined : value)),
    }),
    [selectedFilter]
  );

  return (
    <SelectedVehiclesFilterContext.Provider value={selectedFilterAccessor}>
      {children}
    </SelectedVehiclesFilterContext.Provider>
  );
};
